import {
  Box,
  Divider,
  Grid2,
  List,
  ListItem,
  ListItemText,
  Typography,
  Avatar,
  CircularProgress,
} from '@mui/material';
import ModalComponent from 'components/ModalComponent';
import dayjs from 'dayjs';
import MarkChatReadOutlinedIcon from '@mui/icons-material/MarkChatReadOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { useGetSchoolBoardReadsAsync } from 'services/SchoolBoard/hooks/useQuery';

interface ISchoolBoardReadModalProps {
  isOpen: boolean;
  handleClose: () => void;
  schoolBoardId?: number;
}

const SchoolBoardReadModal = ({
  isOpen,
  handleClose,
  schoolBoardId,
}: ISchoolBoardReadModalProps) => {
  
  const { data: readers, isLoading } = useGetSchoolBoardReadsAsync(schoolBoardId, isOpen);

  return (
    <ModalComponent
      title="Confirmações de Leitura"
      onClose={handleClose}
      isOpen={isOpen}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
            Lista de responsáveis que receberam e leram este recado.
          </Typography>
          <Divider />
        </Grid2>

        <Grid2 size={12}>
          <Box sx={{ maxHeight: '400px', overflowY: 'auto', minHeight: '100px' }}>
            {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={24} />
              </Box>
            ) : readers && readers.length > 0 ? (
              <List sx={{ width: '100%' }}>
                {readers.map((reader: any, index: number) => (
                  <Box key={reader.id || index}>
                    <ListItem alignItems="center">
                      <Avatar sx={{ mr: 2, bgcolor: 'primary.light', width: 32, height: 32 }}>
                        <DoneAllIcon fontSize="small" />
                      </Avatar>
                      <ListItemText
                        primary={reader.userName || 'Usuário'}
                        secondary={
                          <Typography component="span" variant="caption" color="text.secondary">
                            Lido em: {dayjs(reader.readAt).format('DD/MM/YYYY [às] HH:mm')}
                          </Typography>
                        }
                      />
                    </ListItem>
                    {index < readers.length - 1 && <Divider variant="inset" component="li" />}
                  </Box>
                ))}
              </List>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                  Nenhuma leitura confirmada até o momento.
                </Typography>
              </Box>
            )}
          </Box>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default SchoolBoardReadModal;